var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSgpSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.00002C2 4.68631 4.68631 2 8 2C11.3137 2 14 4.68631 14 8.00002",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65213 5.13041C5.65213 4.25624 6.2665 3.52598 7.08691 3.3468C6.96081 3.31928 6.83001 3.30435 6.69559 3.30435C5.68705 3.30435 4.86951 4.1219 4.86951 5.13044C4.86951 6.13898 5.68705 6.95652 6.69559 6.95652C6.82996 6.95652 6.96079 6.94159 7.08691 6.91405C6.2665 6.73487 5.65213 6.00461 5.65213 5.13041Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 3.43478L8.12951 3.83334H8.5486L8.20953 4.07969L8.33904 4.47825L7.99999 4.23194L7.66095 4.47825L7.79046 4.07969L7.45142 3.83334H7.87048L7.99999 3.43478Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98332 4.21738L7.11281 4.61596H7.5319L7.19285 4.86228L7.32236 5.26084L6.98332 5.01453L6.64422 5.26084L6.77376 4.86228L6.43469 4.61596H6.85378L6.98332 4.21738Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 4.21738L9.14613 4.61596H9.5652L9.22613 4.86228L9.35567 5.26084L9.0166 5.01453L8.67755 5.26084L8.80706 4.86228L8.46802 4.61596H8.88708L9.0166 4.21738Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62536 5.3913L8.75488 5.78987H9.17394L8.83489 6.0362L8.96441 6.43476L8.62536 6.18845L8.28631 6.43476L8.41583 6.0362L8.07678 5.78987H8.49582L8.62536 5.3913Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37465 5.3913L7.50414 5.78987H7.92325L7.58418 6.0362L7.71372 6.43476L7.37465 6.18845L7.03558 6.43476L7.1651 6.0362L6.82605 5.78987H7.24514L7.37465 5.3913Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgpSm);
export default __webpack_public_path__ + "static/media/SGP-SM.3b5125f3092d99bc58777b29a6de3a69.svg";
export { ForwardRef as ReactComponent };